/**
 * HTA (Hipertensión Arterial) Pathology Configuration
 *
 * This file contains the complete configuration for the HTA pathology,
 * including modality-specific settings for Protocol and Maintenance modes.
 */

export const MGC_ID = 7;

export const mgcConfig = {
  id: MGC_ID,
  name: "MGC",
  displayNameKey: "mgc", // i18n translation key

  // Feature flags - determines what features are available for this pathology
  // Available features:
  // surveys, ecg, nutrition, howIFeel, modalities, healthBackground, medicalInformation, configParameters
  // Only include features that are enabled (presence = enabled, absence = disabled)
  features: [
    "nutrition",
    "healthBackground",
    "configParameters",
    "customizeFrequency",
    "healthData",
  ],

  components: {
    medicalInfoForm: "ModifyMedicalInformationPSM",
  },

  dashboard: {
    columnSet: 'mgc', // MGC-specific columns
    exportFields: [
      'fullname',
      'antiquity',
      'weekly_adherence',
      'last_data_loaded',
      'hr_today',
      'bp_average_today',
      'oxygen_saturation_today',
      'weight_today',
      'peak_flow_today',
      'body_temperature_today',
      'respiratory_rate_today',
    ],
    exportTransformer: (row, t) => [
      row.fullname,
      row.antiquity,
      row.weekly_adherence != null ? row.weekly_adherence + '%' : '--',
      row.last_data_loaded ? row.last_data_loaded : '--',
      row.hr_today?.value != null ? row.hr_today.value : '--',
      row.bp_average_today?.value ?? '--',
      row.oxygen_saturation_today?.value != null ? row.oxygen_saturation_today.value : '--',
      row.weight_today?.value != null ? row.weight_today.value : '--',
      row.peak_flow_today?.value != null ? row.peak_flow_today.value : '--',
      row.body_temperature_today?.value != null ? row.body_temperature_today.value : '--',
      row.respiratory_rate_today?.value != null ? row.respiratory_rate_today.value : '--',
    ],
    // Chart configurations - MGC uses same charts as MGA
    charts: [
      "weight",
      "blood-pressure",
      "heart-rate",
      "oxygen-saturation",
      "blood-glucose",
    ],
  },

  profileFields: {
    weight: true,
    height: false,
    bmi: false,
    bloodPressure: true,
    heartRate: true,
    ejectionFraction: false,
  },

  alerts: {
    showHowIFeelColumn: false,
    priorityLevels: [1, 2, 3, 4, 5],
  },
};

export default mgcConfig;
